"use client";

import { useEffect } from "react";
// PERF: GSAP + ScrollTrigger loaded lazily via ensureGsap() (out of the initial
// route bundle; registerPlugin after mount). Behavior unchanged.
import { ensureGsap } from "@/lib/EnsureGsap";

/**
 * Client leaf that applies the desktop-only GSAP initial state for the
 * communication-process timeline progress bar and knob. Extracted verbatim
 * from communication-process.tsx so the section itself can render on the
 * server. Renders nothing.
 */
export default function ProgressBarSetup() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let cleanup: (() => void) | null = null;
    let cancelled = false;

    ensureGsap().then(({ gsap }) => {
      if (cancelled) return;

      const ctx = gsap.context(() => {
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
        if (!isDesktop) return;

        const containerEl = document.querySelector<HTMLElement>(
          ".dp-timeline-container",
        );
        const progressEl = document.querySelector<HTMLElement>(
          ".dp-progress-global",
        );
        const knobEl = document.querySelector<HTMLElement>(".dp-progress-knob");

        if (containerEl && progressEl && knobEl) {
          gsap.set(progressEl, { scaleY: 0, transformOrigin: "top" });
          gsap.set(knobEl, { top: 0, xPercent: -50, yPercent: -50 });

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: containerEl,
              start: "top center",
              end: "bottom center",
              scrub: true,
            },
          });

          tl.to(
            progressEl,
            {
              scaleY: 1,
              ease: "none",
            },
            0,
          ).to(
            knobEl,
            {
              top: "100%",
              ease: "none",
            },
            0,
          );
        }
      });

      cleanup = () => ctx.revert();
    });

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);

  return null;
}
